<template>
  <div>
    <vs-prompt
      :title="isNew ? 'Add location' : 'Update location'"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      :accept-text="isNew ? 'Add' : 'Update'"
      :is-valid="validForm"
      class=""
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input v-model="name" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Storage</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select
                v-model="storageId"
                label="Storage"
                placeholder="Select storage"
              >
                <vs-select-item
                  :key="item.storageId.id"
                  :value="item.storageId.id"
                  :text="item.name"
                  v-for="item in venue.storages"
                />
              </vs-select>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      existingId: null,
      name: "",
      storageId: null,
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({
      venue: "pos/venues/venue",
    }),
    isNew() {
      return !this.existingId;
    },
    validForm() {
      return this.name && this.name.length > 0;
    },
  },
  methods: {
    show(withLocation) {
      this.name = "";
      this.existingId = null;
      this.storageId = null;

      if (withLocation) {
        this.existingId = withLocation.locationId.id;
        this.name = withLocation.name;
        if (withLocation.storageId) this.storageId = withLocation.storageId.id;
      }
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();

      if (this.isNew) {
        await this.$store.dispatch("pos/venues/createLocation", {
          venueId: this.venue.id,
          locationName: this.name,
          storageId: this.storageId,
        });
      } else {
        await this.$store.dispatch("pos/venues/updateLocation", {
          venueId: this.venue.id,
          locationId: this.existingId,
          locationName: this.name,
          storageId: this.storageId,
        });
      }

      this.$vs.notify({
        color: "success",
        title: `Venue updated`,
        text: "Venue updated",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
